import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Plus, Trash2 } from "lucide-react";

const DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const VARS = ["{first_name}", "{last_name}", "{company_name}", "{job_title}", "{industry}", "{personalization}"];

export function VarChips({ onInsert }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {VARS.map((v) => (
        <button type="button" key={v} onClick={() => onInsert?.(v)} className="font-mono text-[11px] px-2 py-0.5 rounded-sm bg-slate-100 hover:bg-slate-200 text-slate-700" data-testid={`var-${v.slice(1, -1)}`}>{v}</button>
      ))}
    </div>
  );
}

export function ScheduleEditor({ value, onChange, cap }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const toggleDay = (i) => set("days", value.days.includes(i) ? value.days.filter((d) => d !== i) : [...value.days, i].sort());
  const windows = value.windows || [];
  const setWin = (i, k, v) => set("windows", windows.map((w, j) => (j === i ? { ...w, [k]: v } : w)));
  const toMin = (hm) => { const [h, m] = (hm || "0:0").split(":").map(Number); return h * 60 + m; };
  const total = windows.reduce((a, w) => a + Math.max(0, toMin(w.end) - toMin(w.start)), 0);
  const gap = value.daily_limit ? total / value.daily_limit : 0;
  return (
    <div className="space-y-5" data-testid="schedule-editor">
      <div>
        <Label className="text-xs">Jours d'envoi</Label>
        <div className="flex gap-1.5 mt-2">
          {DAYS.map((d, i) => (
            <button type="button" key={d} onClick={() => toggleDay(i)} data-testid={`day-${i}`}
              className={`w-11 h-9 text-xs rounded border ${value.days.includes(i) ? "bg-[#0b1f3a] text-white border-[#0b1f3a]" : "bg-white text-slate-600 border-slate-300"}`}>{d}</button>
          ))}
        </div>
      </div>
      <div>
        <Label className="text-xs">Plages horaires d'envoi</Label>
        <div className="space-y-2 mt-2" data-testid="schedule-windows">
          {windows.map((w, i) => (
            <div key={i} className="flex items-center gap-2">
              <Input type="time" className="w-32" value={w.start} onChange={(e) => setWin(i, "start", e.target.value)} data-testid={`window-start-${i}`} />
              <span className="text-slate-400 text-sm">à</span>
              <Input type="time" className="w-32" value={w.end} onChange={(e) => setWin(i, "end", e.target.value)} data-testid={`window-end-${i}`} />
              {windows.length > 1 && <button type="button" onClick={() => set("windows", windows.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600" data-testid={`window-remove-${i}`}><Trash2 className="h-4 w-4" /></button>}
            </div>
          ))}
          <button type="button" onClick={() => set("windows", [...windows, { start: "16:00", end: "18:00" }])} className="text-xs text-slate-600 hover:text-[#0b1f3a] flex items-center gap-1" data-testid="window-add"><Plus className="h-3.5 w-3.5" />Ajouter une plage</button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="space-y-1"><Label className="text-xs">Emails / jour{cap ? ` (max ${cap})` : ""}</Label><Input type="number" min={1} max={cap} value={value.daily_limit} onChange={(e) => set("daily_limit", Number(e.target.value))} data-testid="schedule-daily-limit" /></div>
        <div className="space-y-1"><Label className="text-xs">Fuseau horaire</Label><Input value={value.timezone} onChange={(e) => set("timezone", e.target.value)} data-testid="schedule-timezone" /></div>
      </div>
      <p className="text-xs text-slate-500" data-testid="schedule-summary">
        {value.daily_limit} emails répartis automatiquement sur {Math.floor(total / 60)} h {String(total % 60).padStart(2, "0")} d'envoi : environ un email toutes les <b>{gap.toFixed(1)} min</b>, avec un léger décalage aléatoire (±20 %) pour un rythme naturel. Si la journée commence en retard, l'espacement s'ajuste pour rester dans les plages. Minimum 2 min entre deux envois ; le plafond global et les limites Microsoft 365 restent prioritaires.
      </p>
    </div>
  );
}
